import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isEmptyArray } from '@vista-digital/occ-domain';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react';
import { useAnimationConfig } from '../../context/occ/hooks/use-animation-config';
import { AnimateOut } from '../animate-out';
import { Tag } from '../tag/tag';
const b = bemClassBuilder('v-tag-list');
export const TagList = observer(props => {
    const { tags, onTagClicked, onTagButtonClicked, className } = props;
    const { enableAnimations } = useAnimationConfig();
    const animationProps = enableAnimations
        ? {
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0 },
            transition: { stiffness: 500, damping: 50 },
            layout: true
        }
        : {};
    if (isEmptyArray(tags))
        return null;
    return (_jsx("ul", { className: b.block(undefined, className), children: _jsx(AnimateOut, { children: tags.map((tag, i) => (_jsx(motion.li, Object.assign({ className: b.element('tag') }, animationProps, { children: _jsx(Tag, Object.assign({}, tag, { onClick: onTagClicked, onButtonClick: onTagButtonClicked })) }), tag.id || i))) }) }));
});
TagList.displayName = 'Tags';
//# sourceMappingURL=tag-list.js.map